const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

export function printItensTermico({ numero, clienteNome, data, itens, getMaterialNome, funcionarioNome, observacoes }) {
  const grouped = {};
  for (const it of itens || []) {
    const key = it.material_id || 'diverso';
    grouped[key] = (grouped[key] || 0) + (it.quantidade || 1);
  }
  const rows = Object.entries(grouped);
  const total = rows.reduce((s, [, q]) => s + q, 0);
  const fmt = (d) => d ? new Date(d).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' }) : '-';

  const html = `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="utf-8"><title>Recepção ${esc(numero)}</title>
<style>
@page { size: 80mm auto; margin: 0; }
* { box-sizing: border-box; }
html, body { margin: 0; padding: 0; }
body { width: 72mm; padding: 2mm 3mm 6mm; font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 600; color: #000; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
.c { text-align: center; } .b { font-weight: bold; }
h1 { font-size: 15px; margin: 0; text-align: center; } h2 { font-size: 12px; margin: 2px 0 0; text-align: center; font-weight: normal; }
hr { border: 0; border-top: 1px dashed #000; margin: 6px 0; }
table { width: 100%; border-collapse: collapse; } td { padding: 2px 0; vertical-align: top; }
td.q { text-align: right; white-space: nowrap; padding-left: 6px; font-weight: bold; }
.sig { margin-top: 26px; border-top: 1px solid #000; text-align: center; font-size: 11px; padding-top: 2px; }
</style></head><body>
<h1>STERISUL CME</h1><h2>ITENS RECEBIDOS</h2><hr/>
<div>No: <span class="b">${esc(numero)}</span></div>
<div>Data: ${esc(fmt(data))}</div>
<div>Cliente: <span class="b">${esc(clienteNome)}</span></div>
${funcionarioNome ? `<div>Recebido por: ${esc(funcionarioNome)}</div>` : ''}
<hr/>
<table><tr><td class="b">MATERIAL</td><td class="q">QTD</td></tr>
${rows.map(([id, q]) => `<tr><td>${esc(getMaterialNome(id))}</td><td class="q">${q}</td></tr>`).join('')}
</table><hr/>
<table><tr><td class="b">${rows.length} material(is)</td><td class="q">TOTAL: ${total}</td></tr></table>
${observacoes ? `<hr/><div>Obs: ${esc(observacoes)}</div>` : ''}
<hr/>
<div class="sig">Assinatura do Cliente</div>
<div class="sig">Responsável CME</div>
<p class="c" style="font-size:10px;margin-top:8px">Impresso em ${esc(fmt(new Date()))}</p>
<script>window.onload = () => { setTimeout(() => { window.print(); }, 300); }; window.onafterprint = () => window.close();</script>
</body></html>`;

  const w = window.open('', '_blank', 'width=420,height=700');
  if (!w) return false;
  w.document.write(html);
  w.document.close();
  return true;
}
